module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kk-Lc.23e60cd3.png";